const appConfig = {
  apiBaseUrl:
    process.env.REACT_APP_ENVIRONMENT === "development"
      ? "https://uciasampada.com/devapi"
      : "https://uciasampada.com/secondary",
  apiPrefix: "/api",
  authenticatedEntryPath: "app/dashboard",
  unAuthenticatedEntryPath: "/sign-in",
  enableMock: false,
};


export default appConfig;
